import { render } from "./Sala6Es.vue?vue&type=template&id=5e8e24f0"
import script from "./Sala6Es.vue?vue&type=script&lang=js"
export * from "./Sala6Es.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__